import { Flex, FloraButton } from '@grupoboticario/flora-react';
import {
  SmileCircleIcon,
  ThumbDownOutlineIcon,
  NotebookIcon,
  SocialWhatsappIcon,
  PersonPhoneCardIcon,
  ArrowsCircleIcon,
  ChatBubbleOutlineIcon,
} from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { BRANDS } from 'config/environments/shared';
import { getWhatsappLink, isMobile as isMobileHelper } from 'helpers';
import { useGlobalContext } from 'store/contexts';

import Styles from './Central.styles';
import ProfileComponentsStyles from '../Profile.components.styles';

export const Central = () => {
  const isMobile = isMobileHelper();
  const whatsappLink = getWhatsappLink(
    config.communication.whatsapp || '',
    config.communication.message
  );
  const { brand: environmentBrand } = useGlobalContext();
  const isEud = BRANDS.EUD === environmentBrand.short;

  return (
    <Flex gap='$4' direction='column'>
      <ResponsiveFloraTypography fontSize='title' as='h2' fontWeight='bold'>
        {config.communication.title}
      </ResponsiveFloraTypography>
      <Styles.Wrapper direction='column' gap='$6'>
        <Flex direction='column' gap='$3'>
          <ProfileComponentsStyles.SubTitle>
            Entre em contato para:
          </ProfileComponentsStyles.SubTitle>

          <Styles.InfoWrapper>
            {isEud ? (
              <Flex align='center' gap='$2'>
                <PersonPhoneCardIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Atualização de cadastro
                </ProfileComponentsStyles.SubText>
              </Flex>
            ) : (
              <Flex align='center' gap='$2'>
                <SmileCircleIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Elogios e comentários
                </ProfileComponentsStyles.SubText>
              </Flex>
            )}

            <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
              |
            </ResponsiveFloraTypography>
            {isEud ? (
              <Flex align='center' gap='$2'>
                <ArrowsCircleIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Troca e devolução de produtos
                </ProfileComponentsStyles.SubText>
              </Flex>
            ) : (
              <Flex align='center' gap='$2'>
                <ThumbDownOutlineIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Reclamações sobre o atendimento comercial <br /> (Espaço do Revendedor e
                  Supervisor(a)).
                </ProfileComponentsStyles.SubText>
              </Flex>
            )}

            <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
              |
            </ResponsiveFloraTypography>

            {isEud ? (
              <Flex align='center' gap='$2'>
                <ChatBubbleOutlineIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Elogios, comentários e reclamações
                </ProfileComponentsStyles.SubText>
              </Flex>
            ) : (
              <Flex align='center' gap='$2'>
                <NotebookIcon color='$nonInteractiveAuxiliar' size={16} />
                <ProfileComponentsStyles.SubText>
                  Dúvidas ou problemas com o Portal.
                </ProfileComponentsStyles.SubText>
              </Flex>
            )}
          </Styles.InfoWrapper>
        </Flex>

        <Styles.CentralCTA gap='$4'>
          <ResponsiveFloraTypography fontSize='bodyLargeShort'>
            Central de Atendimento
          </ResponsiveFloraTypography>

          <Flex gap='$4'>
            <Styles.ButtonContactWrapper>
              <FloraButton
                as={Link}
                autotagging-flora='on'
                color='$conversionButtonDefault'
                data-flora-text={isMobile ? 'car:conversar' : 'car:conversar-no-whatsapp'}
                data-flora='button'
                rel='noopenner noreferrer'
                target='_blank'
                to={whatsappLink}
              >
                <Flex gap='$2'>
                  <SocialWhatsappIcon size={16} />
                  {isMobile ? 'Conversar' : 'Conversar no WhatsApp'}
                </Flex>
              </FloraButton>
            </Styles.ButtonContactWrapper>
          </Flex>
        </Styles.CentralCTA>
      </Styles.Wrapper>
    </Flex>
  );
};
